// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Headline } from "#/components/headline/Headline";
import { Gallery } from "../../../components/gallery/Gallery";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    Gallery,
  },
})
export class GalleryModule extends ModuleBase {
  private isMobile: boolean = false;

  @Prop({ default: "ErrorWidget" })
  public type!: string;

  public created() {
    window.addEventListener("resize", this.handleResize);
  }

  public mounted() {
    this.handleResize(undefined);
  }

  public destoyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  public getBackgroundColorFromInstance(instance: object) {
    return this.instance["color"];
  }

  private handleResize(e?: Event) {
    const windowWidth =
      document.documentElement!.clientWidth || document.body.clientWidth;

    this.isMobile = windowWidth < 768;
  }

  public isVideo(item) {
    return (
      item["video"] &&
      item["video"] != "" &&
      (item["video"]["embedUrl"] || item["video"]["uploadUrl"])
    );
  }
}
